import PropTypes from "prop-types"
import { Typography, Divider, Box, useTheme } from "@material-ui/core"
import React, { Fragment } from "react"
import CrewStatusTableRow from "./CrewStatusTableRow"

import useStyles from "./styles"

const CrewStatusTable = ({ crewList = [], statusLabel = "" }) => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Box className={classes.columnBox}>
      <Box className={classes.headerBox}>
        <Typography variant="h3" style={{ alignSelf: "flex-start" }}>
          Crew{" "}
          <span style={{ color: "#9A9A9A" }}>
            {crewList && crewList.length}
          </span>
        </Typography>
        {crewList.length > 0 && (
          <Box alignSelf="flex-end" width="15%">
            <Typography
              style={{
                color: theme.palette.success.main,
              }}
            >
              {statusLabel}
            </Typography>
          </Box>
        )}
      </Box>
      {crewList.map((x, i) => {
        return (
          <Fragment key={i}>
            <CrewStatusTableRow role={x} />
            {!(i === crewList.length - 1) && <Divider />}
          </Fragment>
        )
      })}
    </Box>
  )
}

CrewStatusTable.propTypes = {
  crewList: PropTypes.array,
  page: PropTypes.string,
}

export default CrewStatusTable
